// ⚡️ OFFLINE INDICATOR: Offline status banner
// Extracted from ChatPanel.js for better organization and reusability

import React from 'react';

const OfflineIndicator = ({ isOnline, offlineQueue, isDarkMode }) => {
  if (isOnline) return null;

  return (
    <>
      {/* Top Offline Indicator */}
      <div className="absolute top-2 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-black px-3 py-1 rounded-full text-xs font-medium z-10 shadow-lg">
        🔴 Offline - Messages will be sent when you're back online
      </div>
      
      {/* Enhanced Offline Indicator */}
      <div className={`border-l-4 border-yellow-400 p-3 mx-4 mb-3 ${
        isDarkMode ? 'bg-yellow-900/20 border-yellow-500' : 'bg-yellow-50 border-yellow-400'
      }`}>
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className={`h-5 w-5 ${
              isDarkMode ? 'text-yellow-400' : 'text-yellow-400'
            }`} viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className={`text-sm ${
              isDarkMode ? 'text-yellow-200' : 'text-yellow-700'
            }`}>
              <strong>You're offline</strong> - Messages will be sent when you're back online
              {offlineQueue && offlineQueue.length > 0 && (
                <span className="ml-1">({offlineQueue.length} queued)</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfflineIndicator;
